import React, {useContext} from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  GeoAltFill,
  TelephoneFill,
  EnvelopeFill
} from "react-bootstrap-icons";
import "./Footer.scss";
import { ShopContext } from "../context/ShopContext";

function Footer() {
  const { shop } = useContext(ShopContext);
  
  return (
    <footer className="footer">
      <Container>
        <Row>
           
          {/* Brand */}
          <Col md={3} sm={6} className="mb-4">
            <h4 className="footer-logo">{shop?.shopName}</h4>
            <p>
              Discover the latest fashion trends at {shop?.shopName}.
              Premium quality clothing for Men & Women at affordable prices.
            </p>

            <div className="social-icons">
              <Facebook />
              <Instagram />
              <Twitter />
              <Youtube />
            </div>
          </Col>

          {/* Quick Links */}
          <Col md={3} sm={6} className="mb-4">
            <h5>Quick Links</h5>
            <ul>
              <li>Home</li>
              <li>Shop</li>
              <li>New Arrivals</li>
              <li>Top Selling</li>
              <li>Contact Us</li>
            </ul>
          </Col>

          {/* Customer Service */}
          <Col md={3} sm={6} className="mb-4">
            <h5>Customer Service</h5>
            <ul>
              <li>My Account</li>
              <li>Order Tracking</li>
              <li>Terms of Use</li>
              <li>Cancellation & Returns</li>
              <li>Privacy Policy</li>
            </ul>
          </Col>

          {/* Contact */}
          <Col md={3} sm={6} className="mb-4">
            <h5>Contact Us</h5>
            <p><GeoAltFill /> {shop?.address}</p>
            <p><TelephoneFill /> +91 {shop?.phone}</p>
            <p><EnvelopeFill /> {shop?.email}</p>
          </Col>

        </Row>

        <hr style={{border : "1px solid White"}} />

        <div className="footer-bottom text-center">
          © {new Date().getFullYear()} {shop?.shopName}. All Rights Reserved.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;